app.controller('ArticleController', ['$scope','$http','Config','$timeout','cart','toaster','product','CacheFactory','helper',
	function($scope,$http,Config,$timeout,cart,toaster,product,CacheFactory,helper){

	//if no category layout type stored in local storage set the details to grid
	if(!angular.isDefined(CacheFactory.get('appCache').get('categoryLayout'))){
		CacheFactory.get('appCache').put('categoryLayout','grid');
	}

	$scope.categoryLayout = CacheFactory.get('appCache').get('categoryLayout');
	$scope.products = [];
	$scope.productService = product;
	$scope.base_url = Config.base_url;
	$scope.cartService = cart;
	$scope.helper = helper;
	$scope.cart = cart.getCart();

	$scope.init = function(){
		helper.hideLoader();
		$scope.getProducts();
	};

	$scope.getProducts = function(){


        
        window.relatedProducts.forEach(function(e,index) {
            e.data = {
                product_id:e.product_id,
                image:e.image
            };

            $scope.products.push(e);
        });
        console.log($scope.products);
	};

	$scope.switchLayout = function(type,$event){
		if($event.target.attributes.class.value.search("active")==-1){
			$('.shop-grid').fadeOut(function(){
    			$scope.categoryLayout = type;
    			$scope.$apply();
				CacheFactory.get('appCache').put('categoryLayout',type);
	    		$('.shop-grid').fadeIn();
	    	});
		}
	};

	// $scope.cartAdd = function(productIdx, qty){
	// 	if (isNaN(qty) || Number(qty) <= 0) {
	// 		return;
	// 	}
	// 	qty = qty || 1;
	// 	//get product from the group
	// 	cart.add($scope.products[productIdx], qty);
	// 	helper.showAddedtoCart();
	// };


	$scope.cartAdd = function(productIdx,productID,sectionID){

		if (typeof sectionID !== 'undefined') {
			sectionID = 4;
		}
		
        $http({
            method:'POST',
            url: Config.api_url+'counter?section_id='+sectionID+'&brand-key='+Config.brand_key,
            headers: {
                'authorization': Config.api_key
                }
		});
		
		qty = $("input[name*='quantity_"+productID+"']").val();
		if (isNaN(qty) || Number(qty) <= 0) {
			return;
		}
		qty = qty || 1;

		$("input[name*='quantity_"+productID+"']").val(1);
		//get product from the group
		cart.add($scope.products[productIdx], qty);
		helper.showAddedtoCart();
	};

	$scope.changeQty = function(productID,$event){
		if($event){
			qty = $event.target.value;
			$scope.validateQty(qty,productID);
		}
	}

	$scope.incQty = function(productID) {
		var carrentValue = parseInt($("input[name*='quantity_"+productID+"']").val());
		var newvalue = carrentValue +1;
		$("input[name*='quantity_"+productID+"']").val(newvalue);
		$scope.validateQty(newvalue,productID);
	};

	$scope.decQty = function(productID) {
		var carrentValue = parseInt($("input[name*='quantity_"+productID+"']").val());
		if (carrentValue>1) {
			var newvalue = carrentValue -1;
			$("input[name*='quantity_"+productID+"']").val(carrentValue-1);
		} else {
			var newvalue = 1;
			$("input[name*='quantity_"+productID+"']").val(1)
		}
		$scope.validateQty(newvalue,productID);
	};

	$scope.validateQty = function(qty,productID){
		if(!cart.qtyValidation(qty)){
			$("input[name*='quantity_"+productID+"']").addClass('error');
			$(".help-"+productID).show();
			$('.cart-add-'+productID).attr('disabled','disabled');
		}else{
			$("input[name*='quantity_"+productID+"']").removeClass('error');
			$(".help-"+productID).hide();
			$('.cart-add-'+productID).removeAttr('disabled');
		}
	}

}]);



